import React, { useMemo } from 'react'
import { StreetNameResponse } from '../../../api/bridgingFinance/searchPropertyByStreetName'
import '../SearchResultsTable.css'
import { EmptyMessage } from '../../kyc/EmptyMessage'

export interface SearchByStreetNameResultsTableProps {
  entries?: StreetNameResponse[] | null
  title: string
  onRowClick?: (row: StreetNameResponse) => void
}

export const SearchByStreetNameResultsTable: React.FC<
  SearchByStreetNameResultsTableProps
> = ({ entries, title, onRowClick }) => {
  const handleClick = (erf: StreetNameResponse) => () => {
    if (onRowClick) onRowClick(erf)
  }

  const showEmpty = useMemo(() => !entries, [entries])

  if (entries === undefined) return null

  return (
    <div className="kyc-bf-results-table-container">
      <h3 className="table-title">{title}</h3>
      <table>
        <thead>
          <tr style={{ height: '40px' }}>
            <th>Street Name</th>
            <th>Suburb</th>
            <th>Municipality Name</th>
            {/* <th>Allotment</th>
          <th>CMA ID</th> */}
          </tr>
        </thead>
        <tbody>
          {showEmpty && <EmptyMessage />}
          {!showEmpty &&
            entries?.map((entry, index) => (
              <tr
                key={index}
                onClick={handleClick(entry)}
                style={{ height: '30px' }}
              >
                <td>{entry.streetName}</td>
                <td>{entry.suburb}</td>
                <td>{entry.mun_name || '-'}</td>
                {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}
